module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Toast', {}), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "profile",
    on: {
      "click": _vm.menuToggle
    }
  }, [_c('i', {
    staticClass: "pi pi-user"
  }, [_c('span', {
    staticClass: "main-username"
  }, [_vm._v(_vm._s(_vm.user.username))])])]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('h3', [_vm._v(_vm._s(_vm.user.username.toUpperCase())), _c('br'), _c('span')]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
    staticClass: "pi pi-refresh"
  }), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openOrganisationUpdate.apply(null, arguments)
      }
    }
  }, [_vm._v("Update Organisation")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "pi pi-user-edit"
  }), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openDialog.apply(null, arguments)
      }
    }
  }, [_vm._v("Change Password")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "pi pi-sign-out"
  }), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("Logout")])])])])]), _vm._v(" "), _c('form', [_c('Dialog', {
    style: ({
      width: '700px !important'
    }),
    attrs: {
      "header": "Change Password",
      "visible": _vm.changePassword,
      "modal": true,
      "closable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.changePassword = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "dialog-footer"
        }, [_c('Button', {
          staticClass: "p-button-primary",
          attrs: {
            "label": "Send Code",
            "loading": _vm.loading
          },
          on: {
            "click": _vm.updatePassword
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": _vm.cancel
          }
        })], 1)]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('label', {
    attrs: {
      "for": "oldPassword"
    }
  }, [_vm._v("Old Password"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('Password', {
    attrs: {
      "id": "oldPassword",
      "toggleMask": "",
      "feedback": false
    },
    model: {
      value: (_vm.oldPassword),
      callback: function($$v) {
        _vm.oldPassword = $$v
      },
      expression: "oldPassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('label', {
    attrs: {
      "for": "newPass"
    }
  }, [_vm._v("New Password"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('Password', {
    attrs: {
      "id": "newPass",
      "toggleMask": "",
      "feedback": false
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('label', {
    attrs: {
      "for": "confirmPass"
    }
  }, [_vm._v("Confirm Password"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('Password', {
    attrs: {
      "id": "confirmPass",
      "toggleMask": "",
      "feedback": false
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "p-col-12 p-md-12 error-message"
  }, [_vm._v("\n           " + _vm._s(_vm.errorMessage) + "\n         ")]) : _vm._e()])]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '700px !important'
    }),
    attrs: {
      "header": "Verify Code",
      "visible": _vm.showCodeDialog,
      "modal": true,
      "closable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showCodeDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "dialog-footer"
        }, [_c('Button', {
          staticClass: "p-button-primary",
          attrs: {
            "label": "Verify & Reset",
            "loading": _vm.loading
          },
          on: {
            "click": _vm.verifyCodeAndReset
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": _vm.cancel
          }
        })], 1)]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('label', {
    attrs: {
      "for": "verificationCode"
    }
  }, [_vm._v("Verification Code"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "verificationCode",
      "placeholder": "Enter 6-digit code",
      "maxlength": "6"
    },
    model: {
      value: (_vm.verificationCode),
      callback: function($$v) {
        _vm.verificationCode = $$v
      },
      expression: "verificationCode"
    }
  })], 1), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "p-col-12 p-md-12 error-message"
  }, [_vm._v("\n           " + _vm._s(_vm.errorMessage) + "\n         ")]) : _vm._e()])]), _vm._v(" "), _c('UpdateOrganisation', {
    on: {
      "cancel": _vm.cancelUpdateOrg
    },
    model: {
      value: (_vm.updateOrganisation),
      callback: function($$v) {
        _vm.updateOrganisation = $$v
      },
      expression: "updateOrganisation"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c725bc60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/UserMenu.vue
// module id = 2402
// module chunks = 0